import { cr } from "fire-wind-water";

export function updateDirty(list): { [label: string]: unknown } {
  const field = [];
  let isVerify = true;
  let verificationCode = false;
  let scenesKey = "";
  cr.each(list, (d) => {
    const v: { [label: string]: string } = {
      fieldName: d.fieldName,
      value: d.value,
    };
    if (d.fieldType === "LIST" || d.fieldName === "enterprise") {
      v.otherValue = d.otherValue;
    }
    if (d.fieldName === "enterprise") {
      v.thirdValue = d.thirdValue;
    }
    field.push(v);

    d.dirty = true;
    d.sensitivDirty = true;
    if (d.isSendSms == 1) {
      d.verificationCodeDirty = true;
      verificationCode = d.verificationCode;
      scenesKey = d.scenesKey;
    }
    if (d.fieldType === "LIST" && d.listOptionType === "CUSTOM") {
      cr.each(d.listOptions, (m) => {
        m.dirty = true;
      });
    }
    if (d.invalid) {
      isVerify = false;
    }
  });
  return {
    isVerify: isVerify,
    field: field,
    verificationCode: verificationCode,
    scenesKey: scenesKey,
  };
}

export function clearValue(list) {
  cr.each(list, (d) => {
    d.clearValue();
  });
}
